import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mv-macro-head" }
const _hoisted_2 = { class: "mv-macro-search-wrap" }
const _hoisted_3 = { class: "mv-macro-count" }
const _hoisted_4 = {
  key: 0,
  class: "mv-macro-loading"
}
const _hoisted_5 = { class: "mv-macro-form-title" }
const _hoisted_6 = { class: "mv-macro-form-fields" }
const _hoisted_7 = { class: "mv-macro-form-label" }
const _hoisted_8 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_9 = { class: "mv-macro-form-actions" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "mv-macro-result-title" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "mv-macro-steps" }
const _hoisted_14 = { class: "mv-macro-step-icon" }
const _hoisted_15 = {
  key: 0,
  width: "9",
  height: "9",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_16 = {
  key: 1,
  width: "9",
  height: "9",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_17 = { class: "mv-macro-step-body" }
const _hoisted_18 = { class: "mv-macro-step-label" }
const _hoisted_19 = {
  key: 0,
  class: "mv-macro-step-err"
}
const _hoisted_20 = {
  key: 0,
  class: "mv-macro-step mv-macro-step--pending"
}
const _hoisted_21 = { class: "mv-macro-step-body" }
const _hoisted_22 = { class: "mv-macro-step-label" }
const _hoisted_23 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_24 = {
  key: 1,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = {
  key: 0,
  class: "mv-macro-empty"
}
const _hoisted_28 = { class: "mv-macro-list" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "mv-macro-item-info" }
const _hoisted_31 = { class: "mv-macro-item-name" }
const _hoisted_32 = { class: "mv-macro-item-count" }
const _hoisted_33 = {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"flex-shrink":"0","color":"#BC0C24"}
}

import { ref, computed, watch } from 'vue'
import type { Conversation } from '@/types/dashboard'
import { listMacros, type Macro } from '@/services/macrosService'
import { runMacroAction, MACRO_ACTION_LABELS, type MacroActionContext } from '@/services/macroEngineService'
import { fetchConversation } from '@/services/conversationActionsService'


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileMacroSheet',
  props: {
    open: { type: Boolean },
    convId: {},
    conv: {},
    token: {},
    accountId: {}
  },
  emits: ["close", "run-done"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

function close() { emit('close') }

/* ── Estado ─────────────────── */
const macrosList       = ref<Macro[]>([])
const macrosLoading    = ref(false)
const macroSearch      = ref('')
const macroRunning     = ref(false)
const macroRunDone     = ref(false)
const macroRunningObj  = ref<Macro | null>(null)
const macroStepResults = ref<{ label: string; ok: boolean; msg: string }[]>([])
const macroFormStep    = ref(false)
const macroFormFields  = ref<{ idx: number; key: string; label: string; value: string }[]>([])

const filteredMacros = computed(() => {
  const q          = macroSearch.value.trim().toLowerCase()
  const convTeamId = props.conv?.team?.id ?? null
  const active     = macrosList.value.filter(m => {
    if (!m.is_active) return false
    if (!m.team_ids?.length) return true
    return convTeamId ? m.team_ids.includes(convTeamId) : true
  })
  return q ? active.filter(m => m.name.toLowerCase().includes(q)) : active
})

async function loadMacros(force = false) {
  if (macrosList.value.length && !force) return
  macrosLoading.value = true
  try {
    macrosList.value = await listMacros(props.token)
  } catch { /* silencioso */ } finally { macrosLoading.value = false }
}

function resetMacroRun() {
  macroRunning.value     = false
  macroRunDone.value     = false
  macroRunningObj.value  = null
  macroStepResults.value = []
  macroFormStep.value    = false
  macroFormFields.value  = []
}

watch(() => props.open, (isOpen) => {
  if (isOpen) {
    loadMacros()
    resetMacroRun()
  } else {
    macroSearch.value = ''
    resetMacroRun()
  }
})

async function buildMacroContext(macro: Macro): Promise<MacroActionContext> {
  const conv = props.conv
  const base: MacroActionContext = {
    contactPhone:       conv?.contact?.phone ?? null,
    contactName:        conv?.contact?.name  ?? null,
    contactEmail:       (conv?.contact as any)?.email ?? null,
    teamId:             conv?.team?.id   ?? null,
    teamName:           conv?.team?.name ?? null,
    conversationStatus: conv?.status ?? null,
    contactId:          conv?.contact?.id ?? null,
    assigneeId:         conv?.assignee?.id ?? null,
    assigneeName:       conv?.assignee?.name ?? null,
    labels:             conv?.labels ?? [],
    accountId:          props.accountId ?? null,
    macroId:            macro.id,
    macroName:          macro.name,
  }
  const needsLiveContext = macro.actions.some(a => a.action_name === 'send_webhook_event' || a.action_name === 'send_webhook_event_form')
  if (!needsLiveContext || !conv) return base
  const data = await fetchConversation(conv.id, props.token)
  if (!data) return base
  return {
    ...base,
    contactEmail: data?.meta?.sender?.email ?? base.contactEmail,
    inboxId:      data?.inbox_id ?? null,
    inboxName:    data?.channel ?? null,
    rawConversation: data,
  }
}

async function executeMacroActions(macro: Macro, formValuesByIdx: Record<number, Record<string, string>> = {}) {
  if (!props.convId) return
  macroRunningObj.value  = macro
  macroStepResults.value = []
  macroRunDone.value     = false
  macroRunning.value     = true
  macroFormStep.value    = false
  const convId = props.convId
  const context = await buildMacroContext(macro)
  for (const [idx, action] of macro.actions.entries()) {
    const formVals = action.action_name === 'send_webhook_event_form'
      ? (formValuesByIdx[idx] ?? {})
      : undefined
    macroStepResults.value.push(await runMacroAction(action, convId, props.token, context, formVals))
  }
  macroRunning.value = false
  macroRunDone.value = true
  emit('run-done', convId)
}

function runMacro(macro: Macro) {
  const formActions = macro.actions
    .map((a, idx) => ({ action: a, idx }))
    .filter(({ action }) => action.action_name === 'send_webhook_event_form')

  if (formActions.length) {
    macroRunningObj.value = macro
    macroFormFields.value = []
    for (const { action, idx } of formActions) {
      const cfg    = action.action_params?.[0] ?? {}
      const fields: Array<{ key: string; label: string }> = Array.isArray(cfg.fields) ? cfg.fields : []
      for (const field of fields) {
        macroFormFields.value.push({ idx, key: field.key, label: field.label || field.key, value: '' })
      }
    }
    macroFormStep.value = true
  } else {
    executeMacroActions(macro)
  }
}

function submitMacroForm() {
  if (!macroRunningObj.value) return
  const formValuesByIdx: Record<number, Record<string, string>> = {}
  for (const f of macroFormFields.value) {
    if (!formValuesByIdx[f.idx]) formValuesByIdx[f.idx] = {}
    formValuesByIdx[f.idx][f.key] = f.value
  }
  executeMacroActions(macroRunningObj.value, formValuesByIdx)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "mv-sheet-overlay",
          onClick: close
        }, [
          _createElementVNode("div", {
            class: "mv-sheet mv-macro-sheet",
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
          }, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mv-sheet-handle" }, null, -1)),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _cache[3] || (_cache[3] = _createElementVNode("svg", {
                  width: "12",
                  height: "12",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("circle", {
                    cx: "11",
                    cy: "11",
                    r: "8"
                  }),
                  _createElementVNode("line", {
                    x1: "21",
                    y1: "21",
                    x2: "16.65",
                    y2: "16.65"
                  })
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((macroSearch).value = $event)),
                  class: "mv-macro-search",
                  placeholder: "Buscar macro…"
                }, null, 512), [
                  [_vModelText, macroSearch.value]
                ])
              ]),
              _createElementVNode("span", _hoisted_3, _toDisplayString(filteredMacros.value.length), 1)
            ]),
            (macrosLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("div", {
                    class: "mv-spinner",
                    style: {"width":"22px","height":"22px","border-width":"2px"}
                  }, null, -1)
                ]))]))
              : (macroFormStep.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("button", {
                        class: "mv-macro-back-btn",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (macroFormStep.value = false))
                      }, [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("svg", {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                        ], -1),
                        _createTextVNode(" Voltar ", -1)
                      ]))]),
                      _createElementVNode("span", null, _toDisplayString(macroRunningObj.value?.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(macroFormFields.value, (f) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: f.idx + '_' + f.key,
                          class: "mv-macro-form-group"
                        }, [
                          _createElementVNode("label", _hoisted_7, _toDisplayString(f.label || f.key), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((f.value) = $event),
                            class: "mv-macro-form-input",
                            placeholder: f.label || f.key
                          }, null, 8, _hoisted_8), [
                            [_vModelText, f.value]
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("button", {
                        class: "mv-macro-run-btn",
                        onClick: submitMacroForm,
                        disabled: macroRunning.value
                      }, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("svg", {
                          width: "13",
                          height: "13",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("polygon", { points: "5 3 19 12 5 21 5 3" })
                        ], -1),
                        _createTextVNode(" Executar ", -1)
                      ]))], 8, _hoisted_10)
                    ])
                  ], 64))
                : (macroRunning.value || macroRunDone.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("button", {
                          class: "mv-macro-back-btn",
                          onClick: resetMacroRun,
                          disabled: macroRunning.value
                        }, [...(_cache[7] || (_cache[7] = [
                          _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                          ], -1),
                          _createTextVNode(" Voltar ", -1)
                        ]))], 8, _hoisted_12),
                        _createElementVNode("span", null, _toDisplayString(macroRunningObj.value?.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(macroStepResults.value, (r, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i,
                            class: _normalizeClass(["mv-macro-step", r.ok ? 'mv-macro-step--ok' : 'mv-macro-step--err'])
                          }, [
                            _createElementVNode("span", _hoisted_14, [
                              (r.ok)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_15, [...(_cache[8] || (_cache[8] = [
                                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                  ]))]))
                                : (_openBlock(), _createElementBlock("svg", _hoisted_16, [...(_cache[9] || (_cache[9] = [
                                    _createElementVNode("line", {
                                      x1: "18",
                                      y1: "6",
                                      x2: "6",
                                      y2: "18"
                                    }, null, -1),
                                    _createElementVNode("line", {
                                      x1: "6",
                                      y1: "6",
                                      x2: "18",
                                      y2: "18"
                                    }, null, -1)
                                  ]))]))
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, _toDisplayString(r.label), 1),
                              (!r.ok)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(r.msg), 1))
                                : _createCommentVNode("", true)
                            ])
                          ], 2))
                        }), 128)),
                        (macroRunning.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "mv-macro-step-spin" }, null, -1)),
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, _toDisplayString(macroRunningObj.value?.actions[macroStepResults.value.length]
                     ? (_unref(MACRO_ACTION_LABELS)[macroRunningObj.value.actions[macroStepResults.value.length].action_name] ?? '…')
                     : '…'), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (macroRunDone.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["mv-macro-summary", macroStepResults.value.every(r => r.ok) ? 'mv-macro-summary--ok' : 'mv-macro-summary--warn'])
                          }, [
                            (macroStepResults.value.every(r => r.ok))
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_23, [...(_cache[11] || (_cache[11] = [
                                  _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                ]))]))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_24, [...(_cache[12] || (_cache[12] = [
                                  _createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }, null, -1),
                                  _createElementVNode("line", {
                                    x1: "12",
                                    y1: "9",
                                    x2: "12",
                                    y2: "13"
                                  }, null, -1),
                                  _createElementVNode("line", {
                                    x1: "12",
                                    y1: "17",
                                    x2: "12.01",
                                    y2: "17"
                                  }, null, -1)
                                ]))])),
                            (macroStepResults.value.every(r => r.ok))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Concluído com sucesso!"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(macroStepResults.value.filter(r => !r.ok).length) + " ação(ões) com erro", 1))
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      (!macrosList.value.length && !macrosLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, " Nenhuma macro encontrada. "))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_28, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMacros.value, (m) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: m.id,
                            class: "mv-macro-item",
                            onClick: ($event: any) => (runMacro(m))
                          }, [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("span", _hoisted_31, _toDisplayString(m.name), 1),
                              _createElementVNode("span", _hoisted_32, _toDisplayString(m.actions.length) + " ação" + _toDisplayString(m.actions.length !== 1 ? 'ões' : ''), 1)
                            ]),
                            (_openBlock(), _createElementBlock("svg", _hoisted_33, [...(_cache[13] || (_cache[13] = [
                              _createElementVNode("polygon", { points: "5 3 19 12 5 21 5 3" }, null, -1)
                            ]))]))
                          ], 8, _hoisted_29))
                        }), 128))
                      ])
                    ], 64))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})